const ROOT = '/';
const SERVICES_PATH = '/services';
const PRODUCTS_PATH = '/products';
const CONTACT_PATH = '/contact';
const ABOUT_US_PATH = '/about-us'


export{
    ROOT,
    SERVICES_PATH,
    PRODUCTS_PATH,
    CONTACT_PATH,
    ABOUT_US_PATH
}
